export default __webpack_public_path__ + "static/media/n12.a83e158b.svg";